import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cb05dd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "controller" }
const _hoisted_2 = { class: "controller_seek_bar" }
const _hoisted_3 = { class: "seek_bar_wrap" }
const _hoisted_4 = { class: "seek_bar" }
const _hoisted_5 = { class: "controller_buttons" }
const _hoisted_6 = {
  key: 0,
  class: "switch",
  "data-test": "player-controller-live-switch"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "buttons" }

import Slider from '@/components/atoms/Slider'
import IconButton from '@/components/molecules/IconButton'
import SimpleSwitch from '@/components/atoms/SimpleSwitch'
import { formatSecondStr } from '@/js/utils/filters'
import { useBrowserName } from '@/js/utils/util'
import APP from '@/js/const/app'
import i18n from '@/plugins/i18n'
import CameraInfoNav from './components/CameraInfoNav'
import PlayerToolTip from './components/PlayerToolTip'
import {
  CameraDetail,
  ArchiveEventsPeopleCounter,
  ArchiveEvents,
  ArchiveEventsMotionDetect,
  ArchiveEventsEnterAlert,
  UserPermissions,
} from '@/@types/typescript-axios'
import { computed, onMounted, ref, watch, withDefaults } from 'vue'
import { useStore } from 'vuex'

type PropsType = {
  modelValue?: number
  isPaused?: boolean
  currentTime?: number
  duration?: number
  useLive?: boolean
  canLive?: boolean
  cameraDetail?: CameraDetail
  useCapture?: boolean
  useFullScreen?: boolean
  fullScreenFlag?: boolean
  video?: HTMLVideoElement | null
  isVideoLoadError?: boolean
  isMultiVideo?: boolean
  useFullSize?: boolean
  useEventMarker?: boolean
  speed: number
  useSpeedNav?: boolean
  isArchiveLoaded?: boolean
  division?: number
  showController?: boolean
}

type CameraInfoNavPositionType = {
  bottom: string
  right: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  props: {
    modelValue: { default: 0 },
    isPaused: { type: Boolean, default: true },
    currentTime: { default: 0 },
    duration: { default: 60 },
    useLive: { type: Boolean, default: false },
    canLive: { type: Boolean, default: true },
    cameraDetail: null,
    useCapture: { type: Boolean, default: true },
    useFullScreen: { type: Boolean, default: false },
    fullScreenFlag: { type: Boolean, default: false },
    video: { default: null },
    isVideoLoadError: { type: Boolean, default: false },
    isMultiVideo: { type: Boolean, default: false },
    useFullSize: { type: Boolean, default: false },
    useEventMarker: { type: Boolean, default: false },
    speed: null,
    useSpeedNav: { type: Boolean, default: false },
    isArchiveLoaded: { type: Boolean, default: false },
    division: null,
    showController: { type: Boolean, default: true }
  },
  emits: ["togglePlayPause", "changeDivision", "capture", "fullScreen", "showLastArchive", "toggleDirectionController", "toggleLightingController", "showArchiveDownloadDialog", "showEnterAlertCsvDownloadDialog", "change", "changeSoundVolume", "changeSpeed", "showController", "update:modelValue", "update:useLive", "update:fullScreenFlag"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'togglePlayPause'): void
  (e: 'changeDivision', value: number): void
  (e: 'capture'): void
  (e: 'fullScreen'): void
  (e: 'showLastArchive'): void
  (e: 'toggleDirectionController', value: boolean): void
  (e: 'toggleLightingController', value: boolean): void
  (e: 'showArchiveDownloadDialog'): void
  (e: 'showEnterAlertCsvDownloadDialog'): void
  (e: 'showEnterAlertCsvDownloadDialog'): void
  (e: 'change'): void
  (e: 'changeSoundVolume', value: number): void
  (e: 'changeSpeed', value: number): void
  (e: 'showController'): void
  (e: 'update:modelValue', value: number): void
  (e: 'update:useLive', value: boolean): void
  (e: 'update:fullScreenFlag', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: number, isPaused: boolean, currentTime: number, duration: number, useLive: boolean, canLive: boolean, cameraDetail?: CameraDetail, useCapture: boolean, useFullScreen: boolean, fullScreenFlag: boolean, video: HTMLVideoElement | null, isVideoLoadError: boolean, isMultiVideo: boolean, useFullSize: boolean, useEventMarker: boolean, speed: number, useSpeedNav: boolean, isArchiveLoaded: boolean, division?: number, showController: boolean };

const store = useStore()





const formatSecondString = formatSecondStr
const soundVolume = ref<number>(0)
const isShowCamaraInfoNav = ref<boolean>(false)
const showOtherNav = ref<boolean>(false)

onMounted(() => {
  init()
})

const langInfo = computed(() => store.getters['app/langInfo'])
const permissions = computed<UserPermissions>(() => store.getters['auth/permissions'])
const selectedArchiveEvents = computed<ArchiveEvents>(
  () => store.getters['detail/selectedArchiveEvents']
)
const useFullSizeVideo = computed(() => store.getters['detail/useFullSizeVideo'])
const cameraInfo = computed(() => store.getters['detail/cameraInfo'])

const displayLive = computed<boolean>(() => props.canLive && props.useLive)
const displayVideoController = computed<boolean>(() => !props.isVideoLoadError)

const selectedValue = computed({
  get: () => props.modelValue,
  set: (newVal: number) => {
    emit('update:modelValue', newVal)
    // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
    emit('change')
  },
})

const liveState = computed({
  get: () => props.useLive,
  set: (v: boolean) => {
    emit('update:useLive', v)
  },
})

const syncFullScreenFlag = computed({
  get: () => props.fullScreenFlag,
  set: (v: boolean) => {
    emit('update:fullScreenFlag', v)
  },
})

const soundIcon = computed<string>(() => {
  return soundVolume.value > 0 ? 'volume_up' : 'volume_off'
})
/**
 * フルスクリーン切り替え用ボタンのアイコンを切り替え
 */
const fullscreenIcon = computed<string>(() => {
  return syncFullScreenFlag.value ? 'fullscreen_exit' : 'fullscreen'
})
/**
 * その他ボタンの活性、非活性化
 */
const enabledMoreBtn = computed(() => {
  // マルチ映像は分割機能があるので非活性にしない
  // 過去映像は速度変更があるので非活性にしない
  if (props.isMultiVideo || !liveState.value) {
    return true
  } else {
    // 映像詳細のライブ映像はカメラ操作、過去映像ダウンロード、侵入検知が利用できない場合非活性
    return (
      permissions.value.batchDownload || permissions.value.ptz || permissions.value.configEnterAlert
    )
  }
})
/**
 * IEの場合非活性化
 */
const checkIE = computed<boolean>(() => {
  return useBrowserName() !== 'IE'
})
/**
 * fullScreenボタンの活性、非活性化
 * multivideoの場合だけloading中高さが80%になるので
 */
const disabledFullScreenButton = computed<boolean>(() => {
  return props.isMultiVideo ? !props.isArchiveLoaded : false
})

const fullScreenToolTipText = computed<string>(() => {
  return props.fullScreenFlag
    ? i18n.global.t('player_controller.end_of_the_full_screen')
    : i18n.global.t('player_controller.full_screen_display')
})

const fullSizeToolTipText = computed<string>(() => {
  return useFullSizeVideo.value
    ? i18n.global.t('player_controller.end_of_the_full_screen')
    : i18n.global.t('player_controller.full_screen_display')
})
/**
 * カメラ操作の可否
 */
const showToolTipController = computed<boolean>(() => {
  // ライブ映像且つ、利用権限あり且つ、pan、tilt、presetのいずれかが操作可能な場合
  return !props.isMultiVideo && props.cameraDetail !== undefined && props.cameraDetail.use_ptz
})
/**
 * 一括ダウンロードの可否
 */
const showArchiveDownloadNav = computed<boolean>(() => {
  return !props.isMultiVideo
})
/**
 * 侵入検知解析結果CSVダウンロードの可否
 * @return {Boolean} 侵入検知の利用
 */
const showEnterAlertCsvDownloadNav = computed<boolean>(() => {
  return (
    !props.isMultiVideo && props.cameraDetail !== undefined && props.cameraDetail.use_enter_alert
  )
})
/**
 * カメラ照明の可否
 */
const showLightingController = computed<boolean>(() => {
  // TODO TLT様の検証が終わるまで非表示
  return store.getters['app/hasExperimentalFeature']('lighting')
})
/**
 * 音量ボタンの表示・非表示
 */
const showSoundNav = computed<boolean>(() => {
  return !props.isMultiVideo && props.cameraDetail && props.cameraDetail.use_audio
    ? !props.useLive || props.cameraDetail.use_streaming
    : false
})
/**
 * ライブ音量のフラグ
 */
const liveSoundState = computed<boolean>(() => {
  return props.useLive && props.cameraDetail !== undefined && props.cameraDetail.use_streaming
})

const cameraInfoNavPosition = computed<CameraInfoNavPositionType>(() => {
  if (props.isMultiVideo) {
    return {
      bottom: '60px',
      right: '120px',
    }
  } else {
    return {
      bottom: '60px',
      right: '200px',
    }
  }
})

const init = () => {
  if (props.video) {
    if (props.cameraDetail !== undefined && props.cameraDetail.use_audio && !props.video.muted) {
      if (!props.useLive || props.cameraDetail.use_streaming) {
        toggleMute()
      }
    }
  }
}

/**
 * controllerのtooltipのwidth
 * @param {String} text tooltipのtext
 * @return {Number} width tooltipのwidth
 */
const tooltipWidth = (text: string): number => {
  let textWidth = 10
  if (langInfo.value === 'ja') {
    textWidth = 21
  }
  return textWidth * text.length
}

/**
 * モーション検知開始位置のstyle
 * @param {Object} data イベントデータ
 * @return {Object} style用データ
 */
const motionPosition = (data: ArchiveEventsMotionDetect): { width: string; left: string } => {
  return {
    width: 100 * (1 / 60) + '%',
    left: 100 * (Math.floor(data.startSec) / 60) + '%',
  }
}

/**
 * 人数カウント開始位置のstyle
 * @param {Object} data イベントデータ
 * @return {Object} style用データ
 */
const peopleCounterPosition = (
  data: ArchiveEventsPeopleCounter
): { width: string; left: string } | undefined => {
  if (data.inOut !== 'I') {
    return
  }
  const width = data.endSec - data.startSec
  return {
    width: 100 * (width / 60) + '%',
    left: 100 * (Math.floor(data.startSec) / 60) + '%',
  }
}

/**
 * 侵入検知開始位置のstyle
 * @param {Object} data イベントデータ
 * @return {Object} style用データ
 */
const enterAlertPosition = (data: ArchiveEventsEnterAlert): { width: string; left: string } => {
  let width = data.endSec - data.startSec

  // TODO startSecとendSecが同じ場合があるので最小値を設定(ほとんど同じなので▶マークにしたほうがよいか)
  if (width <= 0) {
    width = 1
  }

  return {
    width: 100 * (width / 60) + '%',
    left: 100 * (Math.floor(data.startSec) / 60) + '%',
  }
}

/**
 * 表示時間、モーション検知エリアの表示切り替え用ナビゲーションを表示
 */
const toggleCamaraInfoNav = () => {
  isShowCamaraInfoNav.value = !isShowCamaraInfoNav.value
}

/**
 * その他のナビゲーションを表示
 */
const toggleOtherNav = () => {
  showOtherNav.value = !showOtherNav.value
}

/**
 * 最大幅表示の切り替え
 */
const toggleFullWidthVideo = () => {
  store.commit('detail/setFullWidthVideoState', !useFullSizeVideo.value)
}

/**
 * ミュートの切り替え
 */
const toggleMute = () => {
  if (soundVolume.value > 0) {
    // ミュートする場合はミュート前の値を残しておく
    store.commit('detail/setSoundVolume', soundVolume.value)
    soundVolume.value = 0
  } else {
    // ミュートクリア時はstoreの情報をセットする
    soundVolume.value = store.getters['detail/soundVolume']
  }
  emit('changeSoundVolume', soundVolume.value)
}

const changeSoundVolume = () => {
  store.commit('detail/setSoundVolume', soundVolume.value)
  emit('changeSoundVolume', soundVolume.value)
}

/**
 * 再生速度切り替え
 */
const changeSpeed = () => {
  let nextIndex =
    APP.PLAY_SPEED_OPTIONS.findIndex(
      (d: { label: number; text: string }) => d.label === props.speed
    ) + 1
  //  Safari、Edgeの場合speedが2より高い場合、映像が再生されない不具合があるので制限を2にする
  if (
    ((useBrowserName() === 'edge' || useBrowserName() === 'safari') && props.speed === 2) ||
    nextIndex === APP.PLAY_SPEED_OPTIONS.length
  ) {
    nextIndex = 0
  }
  emit('changeSpeed', APP.PLAY_SPEED_OPTIONS[nextIndex].label)
  emit('showController')
}

watch(
  () => props.showController,
  (v) => {
    if (!v) {
      showOtherNav.value = false
      isShowCamaraInfoNav.value = false
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(IconButton), {
          icon: __props.isPaused ? 'play_arrow' : 'pause',
          "use-border": false,
          "icon-color": "color-white",
          class: "icon-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('togglePlayPause'))),
          onTouchstart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('togglePlayPause')))
        }, null, 8, ["icon"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Slider), {
            modelValue: _unref(selectedValue),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedValue) ? (selectedValue).value = $event : null)),
            max: __props.duration,
            formatTooltip: _unref(formatSecondString)
          }, null, 8, ["modelValue", "max", "formatTooltip"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedArchiveEvents).motionDetect, (data, index) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "motion",
              style: _normalizeStyle(motionPosition(data)),
              key: 'motion-' + index
            }, null, 4))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedArchiveEvents).peopleCounter, (data, index) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "people_counter",
              style: _normalizeStyle(peopleCounterPosition(data)),
              key: 'people_counter-' + index
            }, null, 4))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedArchiveEvents).enterAlert, (data, index) => {
            return (_openBlock(), _createElementBlock("span", {
              class: "enter_alert",
              style: _normalizeStyle(enterAlertPosition(data)),
              key: 'enter_alert-' + index
            }, null, 4))
          }), 128))
        ])
      ], 512), [
        [_vShow, !__props.useLive]
      ]),
      (_unref(showSoundNav))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["sound", { liveSound: _unref(liveSoundState) }])
          }, [
            _createVNode(_unref(IconButton), {
              icon: _unref(soundIcon),
              "use-border": false,
              "icon-color": "color-white",
              class: "icon-button",
              onClick: toggleMute
            }, null, 8, ["icon"]),
            _createVNode(_unref(Slider), {
              modelValue: soundVolume.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((soundVolume).value = $event)),
              max: 1,
              step: 0.1,
              "show-tooltip": false,
              onChange: changeSoundVolume
            }, null, 8, ["modelValue", "step"])
          ], 2))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _unref(displayVideoController)]
    ]),
    _createElementVNode("div", _hoisted_5, [
      (__props.canLive && _unref(permissions).archive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", {
              class: _normalizeClass({ act: _unref(liveState) })
            }, "LIVE", 2),
            _createVNode(_unref(SimpleSwitch), {
              modelValue: _unref(liveState),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(liveState) ? (liveState).value = $event : null))
            }, null, 8, ["modelValue"])
          ]))
        : (_unref(permissions).archive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_unref(IconButton), {
                icon: "skip_next",
                "use-border": false,
                "icon-color": "color-white",
                class: "icon-button skip_next",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('showLastArchive'))),
                "data-test": "player-controller-skip"
              })
            ]))
          : _createCommentVNode("", true),
      (__props.useSpeedNav && _unref(checkIE))
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: "speed_toggle_button",
            onClick: changeSpeed
          }, _toDisplayString(__props.speed) + "x ", 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(IconButton), {
          icon: "visibility",
          "use-border": false,
          "icon-color": "color-white",
          "tool-tip-text": _ctx.$t('player_controller.video_information_display'),
          "tool-tip-width": tooltipWidth(_ctx.$t('player_controller.video_information_display')),
          class: "icon-button",
          onClick: toggleCamaraInfoNav
        }, null, 8, ["tool-tip-text", "tool-tip-width"]),
        (__props.useCapture)
          ? (_openBlock(), _createBlock(_unref(IconButton), {
              key: 0,
              icon: "photo_camera",
              "use-border": false,
              "icon-color": "color-white",
              disabled: !_unref(displayLive),
              "tool-tip-text": _ctx.$t('player_controller.screenshot'),
              "tool-tip-width": tooltipWidth(_ctx.$t('player_controller.screenshot')),
              class: "icon-button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('capture')))
            }, null, 8, ["disabled", "tool-tip-text", "tool-tip-width"]))
          : _createCommentVNode("", true),
        (!__props.fullScreenFlag && __props.useFullSize)
          ? (_openBlock(), _createBlock(_unref(IconButton), {
              key: 1,
              icon: "crop_7_5",
              useBorder: false,
              iconColor: _unref(useFullSizeVideo) ? 'color-primary' : 'color-white',
              toolTipText: _unref(fullSizeToolTipText),
              toolTipWidth: tooltipWidth(_unref(fullSizeToolTipText)),
              class: "icon-button",
              onClick: toggleFullWidthVideo
            }, null, 8, ["iconColor", "toolTipText", "toolTipWidth"]))
          : _createCommentVNode("", true),
        (__props.useFullScreen)
          ? (_openBlock(), _createBlock(_unref(IconButton), {
              key: 2,
              disabled: _unref(disabledFullScreenButton),
              icon: _unref(fullscreenIcon),
              "use-border": false,
              "tool-tipText": _unref(fullScreenToolTipText),
              "tool-tip-width": tooltipWidth(_unref(fullScreenToolTipText)),
              "icon-color": "color-white",
              class: "icon-button",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('fullScreen')))
            }, null, 8, ["disabled", "icon", "tool-tipText", "tool-tip-width"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(IconButton), {
          icon: "more_vert",
          "use-border": false,
          disabled: !_unref(enabledMoreBtn),
          "icon-color": "color-white",
          class: "icon-button",
          onClick: toggleOtherNav,
          "data-test": "player-controller-more-btn"
        }, null, 8, ["disabled"])
      ])
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (isShowCamaraInfoNav.value)
          ? (_openBlock(), _createBlock(_unref(CameraInfoNav), {
              key: 0,
              "camera-info": _unref(cameraInfo),
              position: _unref(cameraInfoNavPosition),
              "is-multi-video": __props.isMultiVideo,
              onMouseleave: toggleCamaraInfoNav
            }, null, 8, ["camera-info", "position", "is-multi-video"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (showOtherNav.value)
          ? (_openBlock(), _createBlock(_unref(PlayerToolTip), {
              key: 0,
              "use-controller": _unref(showToolTipController),
              "use-archive-download-nav": _unref(showArchiveDownloadNav),
              "use-enter-alert-csv-download-nav": _unref(showEnterAlertCsvDownloadNav),
              "use-lighting-controller": _unref(showLightingController),
              "live-state": _unref(liveState),
              division: __props.division,
              "is-multi-video": __props.isMultiVideo,
              permissions: _unref(permissions),
              onMouseleave: toggleOtherNav,
              onShowDirectionController: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('toggleDirectionController', true))),
              onShowLightingController: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('toggleLightingController', true))),
              onShowArchiveDownloadDialog: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('showArchiveDownloadDialog'))),
              onShowEnterAlertCsvDownloadDialog: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('showEnterAlertCsvDownloadDialog'))),
              onChangeDivision: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('changeDivision', $event)))
            }, null, 8, ["use-controller", "use-archive-download-nav", "use-enter-alert-csv-download-nav", "use-lighting-controller", "live-state", "division", "is-multi-video", "permissions"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})